import { Api } from "@relode/core";

import { FeedbackRequest } from ".";

export const feedbackService = {
    addFeedback: async (
        jobId: number,
        leadId: number,
        feedback: FeedbackRequest,
        signal?: AbortSignal
    ) => {
        const url = `/candidates/${jobId}/${leadId}/feedback`;
        await Api.url(url)
            .useSignal(signal)
            .track({ name: "getCandidateDetails", data: { jobId, leadId } })
            .post<never>(feedback);
    },

    updateFeedback: async (
        jobId: number,
        leadId: number,
        feedback: FeedbackRequest,
        signal?: AbortSignal
    ) => {
        const url = `/candidates/${jobId}/${leadId}/feedback/details`;
        await Api.url(url)
            .useSignal(signal)
            .track({ name: "updateFeedback", data: { jobId, leadId } })
            .put<never>(feedback);
    },
};
